import React, { useEffect, useState, useContext, useRef } from 'react'
import { useDispatch } from 'react-redux'
import { showSidebar } from '../slices/ui'

import SearchIcon from '../icons/search.svg'

const SearchControl = (props) => {
  const {className=""} = props
  const dispatch = useDispatch()
  return (
    <button className={"button secondary circular fa " + className} 
            onClick={() => dispatch(showSidebar('search'))}
            tabIndex={0}>
            <SearchIcon/>
    </button>
  )
}

export default SearchControl;

